import {GetWorkshopOverviewApiResponse} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

import {WorkshopTileId} from '../types/WorkshopOverviewTileConfig';

// Maps the overview endpoint response onto tile ids. Missing groups (nullable in
// the API contract) resolve to Nullish counts, which hide the affected tiles.
export function mapWorkshopOverviewCounts(overview: GetWorkshopOverviewApiResponse) {
  return {
    vehiclesNotArrived: overview?.critical?.vehicleNotArrived,
    overpricedOrders: overview?.critical?.overpricedOrders,
    overdueOrders: overview?.critical?.overdueOrders,
    ordersBelowMinimumMargin: overview?.critical?.belowMinimumMargin,
    unclosedWarrantyClaims: overview?.warning?.unclosedWarrantyOrClaim,
    ordersWithoutCompletionDate: overview?.warning?.noCompletionDate,
    ordersWithoutEstimatedPrice: overview?.warning?.noEstimatedPriceSet,
    repeatedRepairs: overview?.warning?.repeatedRepairs,
    toCompleteToday: overview?.today?.toCompleteToday,
    todaysVehicleArrivals: overview?.today?.todayVehicleArrivals,
  } satisfies Record<WorkshopTileId, number | Nullish>;
}
